import React, { lazy } from 'react'
import content from './content';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function skills() {
    return (
        <div className="flex flex-col pb-10">
            <header className='text-2xl font-bold pt-10 pb-5 items-start px-5'>
                    <h2 className="heading text-yellow-600">Skills & Tools</h2>
            </header>
            <div className="flex flex-wrap justify-center">
                {content.stack.tech.map((tech, index) => {
                    return <span
                    className='w-24 h-24 bg-gray-200 shadow-2xl m-2 rounded-full flex items-center p-5    transition duration-500 ease-in-out hover: transform hover:-translate-y-2-x-2 hover:scale-125'
                  >
                        <LazyLoadImage src={tech.img} alt={tech.alt} />
                    </span>
                })}
            </div>
        </div>
    )
}

export default skills
